'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fixUncontrolledValue(value) {
  return typeof value === 'undefined' || value === null ? '' : value;
}

var Input = (_temp2 = _class = function (_Element) {
  (0, _inherits3.default)(Input, _Element);

  function Input() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Element.call.apply(_Element, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Input.prototype.getValue = function getValue() {
    return fixUncontrolledValue(_Element.prototype.getValue.call(this));
  };

  Input.prototype.onChange = function onChange(evn) {
    var _this2 = this;

    var target = evn.target;

    var value = target.value;

    if (target.type === 'checkbox') {
      value = !!target.checked;
    } else if (target.type === 'radio' && target.checked) {
      value = this.props.value;
    } else if (target.type === 'number') {
      var fixedValue = value.replace(',', '.').replace(' ', '');

      // fix decimal numbers
      var numberValue = Number(fixedValue);
      if (numberValue.toString() === fixedValue) {
        value = numberValue;
      }
    }

    var type = this.props.type;


    if (type === 'checkbox' || type === 'radio') {
      setTimeout(function () {
        _this2.setValue(value);
        var onChange = _this2.props.onChange;


        if (typeof onChange === 'function') {
          onChange(evn);
        }
      }, 0);
    } else {
      this.setValue(value);
      var onChange = this.props.onChange;

      if (typeof onChange === 'function') {
        onChange(evn);
      }
    }
  };

  Input.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this.clearTimeout();
  };

  Input.prototype.clearTimeout = function (_clearTimeout) {
    function clearTimeout(_x) {
      return _clearTimeout.apply(this, arguments);
    }

    clearTimeout.toString = function () {
      return _clearTimeout.toString();
    };

    return clearTimeout;
  }(function (sendValue) {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }

    // TODO validate this
    if (sendValue && this.props.value !== this.getValue()) {
      this.notifyParent(this.getValue(), this, sendValue);
    }
  });

  Input.prototype.componentWillUnmount = function componentWillUnmount() {
    _Element.prototype.componentWillUnmount.call(this);
    this.clearTimeout();
  };

  Input.prototype.notifyParent = function notifyParent(value, component, force) {
    var _this3 = this;

    var type = this.props.type;

    var debounce = this.getDebounce();

    if (!this.focused || !debounce || type === 'checkbox' || type === 'radio') {
      _Element.prototype.notifyParent.call(this, value, component);
      return;
    }

    this.clearTimeout();

    if (force) {
      _Element.prototype.notifyParent.call(this, value, component, force);
      return;
    }

    this.timeoutId = setTimeout(function () {
      _this3.timeoutId = null;
      _Element.prototype.notifyParent.call(_this3, value, component);
    }, debounce);
  };

  Input.prototype.getClassName = function getClassName() {
    return this.props.className;
  };

  Input.prototype.getDebounce = function getDebounce() {
    var debounce = this.props.debounce;

    if (typeof debounce !== 'undefined') {
      return debounce;
    }

    return this.getForm().props.debounce;
  };

  Input.prototype.getGroupName = function getGroupName(group) {
    if (!group) {
      return undefined;
    }

    return this.getPathByName(group);
  };

  Input.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        name = _props.name,
        group = _props.group,
        type = _props.type,
        debounce = _props.debounce,
        originalValue = _props.value,
        rest = (0, _objectWithoutProperties3.default)(_props, ['name', 'group', 'type', 'debounce', 'value']);


    var value = this.getValue();

    var checked = type === 'checkbox' && value || type === 'radio' && value === originalValue;

    if (type === 'radio' && originalValue) {
      value = originalValue;
    }

    var isCheckbox = type === 'checkbox' || type === 'radio';
    var isRadio = type === 'radio';
    var newName = isRadio ? this.getGroupName(group) : undefined;

    return _react2.default.createElement('input', (0, _extends3.default)({}, rest, {
      name: newName,
      className: this.getClassName(),
      type: type,
      value: value,
      checked: isCheckbox ? checked : undefined,
      onChange: function onChange() {
        return _this4.onChange.apply(_this4, arguments);
      },
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyPress: this.onKeyPress
    }));
  };

  return Input;
}(_Element3.default), _class.propTypes = (0, _extends3.default)({}, _Element3.default.propTypes, {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  autoComplete: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool,
  debounce: _propTypes2.default.number,
  group: _propTypes2.default.string
}), _class.defaultProps = {
  autoComplete: 'off',
  type: 'text',
  group: undefined
}, _class.contextTypes = (0, _extends3.default)({}, _Element3.default.contextTypes), _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onKeyPress = function (evn) {
    if (evn.key === 'Enter') {
      _this5.clearTimeout(true);
    }
  };

  this.onFocus = function () {
    var onFocus = _this5.props.onFocus;


    _this5.focused = true;

    if (onFocus) {
      onFocus.apply(undefined, arguments);
    }
  };

  this.onBlur = function () {
    var onBlur = _this5.props.onBlur;


    _this5.focused = false;
    _this5.clearTimeout(true);

    if (onBlur) {
      onBlur.apply(undefined, arguments);
    }
  };
}, _temp2);
exports.default = Input;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Input.js
 ** module id = 237
 ** module chunks = 0
 **/